export const FETCH_EVENT_DATA = 'FETCH_EVENT_DATA'
export const FETCH_EVENT_DATA_SUCCESS = 'FETCH_EVENT_DATA_SUCCESS'

export const FETCH_EVENT_REGISTRATION_DATA = 'FETCH_EVENT_REGISTRATION_DATA'
export const FETCH_EVENT_REGISTRATION_DATA_SUCCESS =
  'FETCH_EVENT_REGISTRATION_DATA_SUCCESS'

export const UPDATE_EVENT_DATA = 'UPDATE_EVENT_DATA'
export const UPDATE_EVENT_DATA_SUCCESS = 'UPDATE_EVENT_DATA_SUCCESS'
